import { useLoaderData } from "react-router-dom";

import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import DETAIL_TEMPLATE from "../config/detail.template";
import useOnClickEventListener from "../hooks/useOnClickEventListener";
import { useViewDetailStore } from "../store/viewDetailStore";

import FieldLabel from "./FieldLabel";
import FieldValue from "./FieldValue";
import EditModal from "./modal/EditModal";


export default function ViewDetails({ data = {} }) {
  const { viewName } = useLoaderData();
  const { openModal, loading } = useViewDetailStore();
  const { handleOnClickCloseModalButton } = useOnClickEventListener();
  const fields = DETAIL_TEMPLATE[viewName]?.displayMode;

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <div className="flex w-full flex-col gap-3 p-4">
        {fields &&
          Object.keys(fields).map((fieldKey) => {
            const field = fields[fieldKey];
            const fieldLabel = field?.label;
            const display = field?.display;
            if (!display) {
              return null;
            }
            return (
              <div key={fieldKey} className="flex flex-col gap-1">
                <FieldLabel value={fieldLabel} />
                <FieldValue field={field} data={data} />
              </div>
            );
          })}
      </div>
      <EditModal openModal={openModal} handleCloseModal={handleOnClickCloseModalButton} />
    </>
  );
}
